import { render, staticRenderFns } from "./secondStep.vue?vue&type=template&id=c8312ed4"
import script from "./secondStep.vue?vue&type=script&lang=ts"
export * from "./secondStep.vue?vue&type=script&lang=ts"
import style0 from "./secondStep.vue?vue&type=style&index=0&id=c8312ed4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports